function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React from 'react';
import { motion } from 'framer-motion';
import { Badge, Button, LinkBox, LinkOverlay, Heading, Flex, Box, Menu, MenuButton, IconButton, MenuList, MenuItem, MenuGroup, Icon, icons, TapTheme } from '@tapresearch/ui/components';
import { Styles as S } from './SiteNav';
var MotionItem = motion(MenuItem);
var MotionBox = motion(Box);
var iconMotion = {
    rest: {
        color: TapTheme.colors.gray[500],
        scale: 0.9,
        rotate: 0,
        opacity: 0.8,
        transition: {
            type: 'spring',
            bounce: 0.1
        }
    },
    hover: {
        scale: [
            0.9,
            1,
            1.1,
            1
        ],
        color: 'var(--chakra-colors-blue-500)',
        rotate: [
            0,
            0,
            30,
            -10,
            0
        ],
        opacity: 1,
        transition: {
            type: 'spring',
            duration: 0.5,
            bounce: 0.5
        }
    }
};
export var ProductMenu = function(param) {
    var currentProduct = param.currentProduct, isMobile = param.isMobile, asset = param.asset, user = param.user;
    var isSupplier = !!user.organization.supplier;
    var isCustomer = !!user.organization.customer;
    var noOps = user.organization_membership.role === asset.constants.ORGANIZATION_ROLE_CUSTOMER_SUCCESS;
    var _asset_constants = asset.constants, TAP_PRODUCT_SNAPSHOT = _asset_constants.TAP_PRODUCT_SNAPSHOT, TAP_PRODUCT_MONETIZATION = _asset_constants.TAP_PRODUCT_MONETIZATION, TAP_PRODUCT_SAMPLE = _asset_constants.TAP_PRODUCT_SAMPLE, TAP_PRODUCT_PLAYER_INSIGHTS = _asset_constants.TAP_PRODUCT_PLAYER_INSIGHTS;
    var TapResearchProducts = asset.active_enum.TapResearchProducts;
    var productKey = isSupplier && currentProduct === TAP_PRODUCT_SNAPSHOT ? TAP_PRODUCT_PLAYER_INSIGHTS : currentProduct;
    var _obj;
    var productIcons = (_obj = {}, _define_property(_obj, TAP_PRODUCT_SNAPSHOT, icons.fa.RegChartBar), _define_property(_obj, TAP_PRODUCT_SAMPLE, icons.io4.MdGlobe), _define_property(_obj, TAP_PRODUCT_MONETIZATION, icons.md.OutlineAttachMoney), _define_property(_obj, TAP_PRODUCT_PLAYER_INSIGHTS, icons.md.PersonSearch), _obj);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Menu, {
        autoSelect: false
    }, !isMobile && TapResearchProducts[productKey] ? /*#__PURE__*/ React.createElement(MenuButton, _object_spread({
        as: Button,
        "aria-label": "Product Menu",
        className: "product-btn",
        rightIcon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 6,
            ml: 0,
            icon: icons.io5.Apps
        }),
        role: "group"
    }, S.NavButton, Styles.CurrentProductButton), /*#__PURE__*/ React.createElement(Flex, Styles.CurrentProduct, /*#__PURE__*/ React.createElement(Flex, {
        align: "center"
    }, /*#__PURE__*/ React.createElement(Icon, _object_spread_props(_object_spread({}, Styles.MenuButtonIcon), {
        boxSize: 6,
        icon: productIcons[productKey]
    }))), /*#__PURE__*/ React.createElement(Heading, Styles.MenuButtonHeading, TapResearchProducts[productKey].name))) : /*#__PURE__*/ React.createElement(MenuButton, _object_spread({
        as: IconButton,
        "aria-label": "Product Menu",
        icon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 6,
            icon: icons.io5.Apps
        })
    }, S.NavButton)), /*#__PURE__*/ React.createElement(MenuList, Styles.MenuDropdown, isSupplier ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Monetization, {
        constants: asset.constants,
        currentProduct: productKey,
        TapResearchProducts: TapResearchProducts,
        productIcons: productIcons
    }), isCustomer && user.organization.developer_surveys_active && /*#__PURE__*/ React.createElement(Research, {
        isSupplier: true,
        constants: asset.constants,
        currentProduct: productKey,
        TapResearchProducts: TapResearchProducts,
        productIcons: productIcons,
        noOps: noOps
    })) : /*#__PURE__*/ React.createElement(Research, {
        isSupplier: false,
        constants: asset.constants,
        currentProduct: productKey,
        TapResearchProducts: TapResearchProducts,
        productIcons: productIcons,
        noOps: noOps
    }))));
};
var Monetization = function(param) {
    var constants = param.constants, TapResearchProducts = param.TapResearchProducts, productIcons = param.productIcons, currentProduct = param.currentProduct;
    var TAP_PRODUCT_MONETIZATION = constants.TAP_PRODUCT_MONETIZATION;
    return /*#__PURE__*/ React.createElement(MenuGroup, {
        title: "App Monetization"
    }, /*#__PURE__*/ React.createElement(MotionItem, _object_spread({
        initial: "rest",
        whileHover: "hover",
        animate: "rest",
        as: LinkBox
    }, Styles.MenuItem), /*#__PURE__*/ React.createElement(MotionBox, {
        variants: iconMotion
    }, /*#__PURE__*/ React.createElement(Icon, _object_spread_props(_object_spread({}, Styles.MenuItemIcon), {
        icon: productIcons[TAP_PRODUCT_MONETIZATION]
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(LinkOverlay, {
        href: TapResearchProducts[TAP_PRODUCT_MONETIZATION].link
    }, /*#__PURE__*/ React.createElement(Heading, Styles.MenuItemHeading, TapResearchProducts[TAP_PRODUCT_MONETIZATION].name, TAP_PRODUCT_MONETIZATION === currentProduct && /*#__PURE__*/ React.createElement(Badge, Styles.CurrentBadge, "Current")), /*#__PURE__*/ React.createElement(MotionBox, Styles.MenuItemText, /*#__PURE__*/ React.createElement("span", null, TapResearchProducts[TAP_PRODUCT_MONETIZATION].description))))));
};
var Research = function(param) {
    var isSupplier = param.isSupplier, constants = param.constants, TapResearchProducts = param.TapResearchProducts, productIcons = param.productIcons, currentProduct = param.currentProduct, _param_noOps = param.noOps, noOps = _param_noOps === void 0 ? false : _param_noOps;
    var TAP_PRODUCT_PLAYER_INSIGHTS = constants.TAP_PRODUCT_PLAYER_INSIGHTS, TAP_PRODUCT_SNAPSHOT = constants.TAP_PRODUCT_SNAPSHOT, TAP_PRODUCT_SAMPLE = constants.TAP_PRODUCT_SAMPLE;
    return isSupplier ? /*#__PURE__*/ React.createElement(MenuGroup, {
        className: "research",
        title: "Research"
    }, /*#__PURE__*/ React.createElement(MotionItem, _object_spread({
        initial: "rest",
        whileHover: "hover",
        animate: "rest",
        as: LinkBox
    }, Styles.MenuItem), /*#__PURE__*/ React.createElement(MotionBox, {
        variants: iconMotion
    }, /*#__PURE__*/ React.createElement(Icon, _object_spread_props(_object_spread({}, Styles.MenuItemIcon), {
        icon: productIcons[TAP_PRODUCT_PLAYER_INSIGHTS]
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(LinkOverlay, {
        href: TapResearchProducts[TAP_PRODUCT_PLAYER_INSIGHTS].link
    }, /*#__PURE__*/ React.createElement(Heading, Styles.MenuItemHeading, TapResearchProducts[TAP_PRODUCT_PLAYER_INSIGHTS].name, TAP_PRODUCT_PLAYER_INSIGHTS === currentProduct && /*#__PURE__*/ React.createElement(Badge, Styles.CurrentBadge, "Current")), /*#__PURE__*/ React.createElement(MotionBox, Styles.MenuItemText, /*#__PURE__*/ React.createElement("span", null, TapResearchProducts[TAP_PRODUCT_PLAYER_INSIGHTS].description)))))) : /*#__PURE__*/ React.createElement(MenuGroup, {
        className: "research",
        title: "Research"
    }, /*#__PURE__*/ React.createElement(MotionItem, _object_spread({
        initial: "rest",
        whileHover: "hover",
        animate: "rest",
        as: LinkBox
    }, Styles.MenuItem), /*#__PURE__*/ React.createElement(MotionBox, {
        variants: iconMotion
    }, /*#__PURE__*/ React.createElement(Icon, _object_spread_props(_object_spread({}, Styles.MenuItemIcon), {
        icon: productIcons[TAP_PRODUCT_SNAPSHOT]
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(LinkOverlay, {
        href: TapResearchProducts[TAP_PRODUCT_SNAPSHOT].link
    }, /*#__PURE__*/ React.createElement(Heading, Styles.MenuItemHeading, TapResearchProducts[TAP_PRODUCT_SNAPSHOT].name, TAP_PRODUCT_SNAPSHOT === currentProduct && /*#__PURE__*/ React.createElement(Badge, Styles.CurrentBadge, "Current")), /*#__PURE__*/ React.createElement(MotionBox, Styles.MenuItemText, /*#__PURE__*/ React.createElement("span", null, TapResearchProducts[TAP_PRODUCT_SNAPSHOT].description))))), !noOps && /*#__PURE__*/ React.createElement(MotionItem, _object_spread({
        initial: "rest",
        whileHover: "hover",
        animate: "rest",
        as: LinkBox
    }, Styles.MenuItem), /*#__PURE__*/ React.createElement(MotionBox, {
        variants: iconMotion
    }, /*#__PURE__*/ React.createElement(Icon, _object_spread_props(_object_spread({}, Styles.MenuItemIcon), {
        icon: productIcons[TAP_PRODUCT_SAMPLE]
    }))), /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(LinkOverlay, {
        href: TapResearchProducts[TAP_PRODUCT_SAMPLE].link
    }, /*#__PURE__*/ React.createElement(Heading, Styles.MenuItemHeading, TapResearchProducts[TAP_PRODUCT_SAMPLE].name), /*#__PURE__*/ React.createElement(MotionBox, Styles.MenuItemText, /*#__PURE__*/ React.createElement("span", null, TapResearchProducts[TAP_PRODUCT_SAMPLE].description))))));
};
var Styles = {
    CurrentProduct: {
        h: '100%',
        rounded: 0,
        mr: 0,
        align: 'center',
        p: '0 15px'
    },
    CurrentBadge: {
        colorScheme: 'blue',
        variant: 'subtle',
        fontWeight: 'bold',
        p: '4px'
    },
    CurrentProductButton: {
        h: 10,
        px: 2,
        p: 0,
        overflow: 'hidden',
        rounded: 'md',
        border: '1px solid',
        borderColor: 'gray.200',
        alignItems: 'stretch',
        sx: {
            '.chakra-button__icon': {
                ml: 0,
                color: 'gray.700',
                h: '100%',
                display: 'flex',
                alignItems: 'center',
                p: '0 10px',
                borderLeft: '1px solid #EEE',
                transitionProperty: 'common',
                transitionDuration: 'normal'
            },
            _active: {
                bg: 'gray.50',
                borderColor: 'blue.500',
                '.chakra-button__icon': {
                    bg: 'gray.50',
                    color: 'blue.500'
                }
            },
            _hover: {
                bg: 'gray.50',
                borderColor: 'blue.500',
                '.chakra-button__icon': {
                    bg: 'gray.50',
                    color: 'blue.500'
                }
            }
        }
    },
    ProductButton: {
        h: 12,
        mr: 6,
        ml: 4,
        variant: 'ghost',
        colorScheme: 'blue',
        bg: 'none',
        boxShadow: 'sm',
        border: '1px solid',
        borderColor: '#ccc',
        borderRadius: '6px',
        transitionDuration: '.3s',
        _hover: {
            bg: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.12),
            borderColor: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.12)
        },
        _active: {
            color: 'blue.500',
            bg: TapTheme.fn.rgba(TapTheme.colors.blue[500], 0.05)
        }
    },
    MenuButtonHeading: {
        mr: 3,
        fontSize: 'md',
        color: '#555',
        justifyContent: 'center',
        fontWeight: 'semibold',
        letterSpacing: 'wider',
        textTransform: 'uppercase',
        lineHeight: 'normal'
    },
    MenuButtonIcon: {
        color: 'blue.500',
        mr: 3
    },
    MenuItem: {
        py: 3,
        px: 4,
        flexGrow: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'flex-start',
        w: 'calc(100% - 15px)',
        m: '0 auto',
        rounded: 'md',
        border: '2px solid',
        borderColor: 'white',
        transitionProperty: 'border, background',
        transitionDuration: 'normal',
        overflow: 'hidden',
        maxW: {
            base: 'fit-content',
            md: 'none'
        },
        sx: {
            a: {
                textDecoration: 'none'
            }
        },
        _hover: {
            borderColor: 'blue.500'
        },
        _focus: {
            bg: 'blue.50'
        }
    },
    MenuDropdown: {
        zIndex: 'popover',
        boxShadow: 'lg',
        display: 'flex',
        flexDirection: 'column',
        minW: '300px',
        maxW: {
            base: '100%',
            md: '450px'
        },
        w: {
            base: '100vw',
            md: 'auto'
        },
        py: 5,
        px: 3,
        alignItems: 'flex-start',
        sx: {
            '.chakra-menu__group': {
                w: 'full',
                display: 'flex',
                flexDirection: 'column'
            },
            '.chakra-menu__group__title': {
                color: 'gray.400',
                px: 2,
                pt: 2,
                pb: 1,
                mt: 0,
                mx: 3,
                fontWeight: 'normal'
            },
            '.chakra-menu__group:not(:first-of-type)': {
                mt: 2
            }
        }
    },
    MenuItemHeading: {
        fontSize: '16px',
        color: 'gray.700',
        py: '3px',
        justifyContent: 'space-between',
        align: 'center',
        fontWeight: 'semibold'
    },
    MenuItemText: {
        fontSize: '.85rem',
        fontWeight: 'medium',
        color: 'gray.600',
        pt: 1
    },
    MenuItemIcon: {
        boxSize: 6,
        color: 'inherit',
        mr: 4
    }
};
